<template>
<div class="chapter">
<div class="inner_page">
<section aria-label="Part One" role="doc-part">
<h1 class="h1p"><span aria-label="page viii" id="page_viii" role="doc-pagebreak"><span aria-label="page 1" id="page_1" role="doc-pagebreak">PART ONE</span></span></h1>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?6bd98e13